import {
  IconShare,
  IconBrandWhatsapp,
  IconBrandTelegram,
  IconClipboard, IconClipboardText, IconMailFast, IconX
} from "@tabler/icons"
import { Badge, Button, Modal, Overlay, Textarea, Group, Divider, Paper, ActionIcon } from "@mantine/core"
import { useState } from "react"
import { useForm } from "@mantine/form"
import { useAppSelector } from "../../utils/hooks"
import { rootUrl } from "../../utils/constants"
import { useClipboard } from "@mantine/hooks"
import { AutocompleteUsers } from "./AutocompleteUsers"
import { sendNotification } from "../../api/api-notifications"
import { showNotification } from "@mantine/notifications"

interface Props {
  id: number; // Id movie
  title: string;
}

interface SelectedFriend {
  id: string;
  name: string;
  avatar: string;
}

export const BtnShareMovie = ({ id, title }: Props) => {

  const [isLoading, setIsLoading] = useState(false)
  const [modalOpened, setModalOpened] = useState(false)
  const [selectedFriends, setSelectedFriends] = useState<SelectedFriend[]>([])

  const userState = useAppSelector((state) => state.user)

  const clipboard = useClipboard({ timeout: 3000 });

  const form = useForm({
    initialValues: {
      note: '',
    }
  });

  const url = `${rootUrl}/movie/${id}`
  const message = `Hai già visto "${title}"? Aggiungilo alla tua watchlist su Moviebook!`

  const sendMovieSuggest = async (values: any) => {

    setIsLoading(true)

    const text = values.note ?
      `${userState.data.name} ti consiglia di aggiungere "${title}" alla tua watchlist. Ti annota che: "${values.note}"`
      :
      `${userState.data.name} ti consiglia di aggiungere "${title}" alla tua watchlist`

    await Promise.all(
      selectedFriends.map(async (friend) => {
        await sendNotification(
          friend.id,
          "movieSuggested",
          text,
          userState.data.docId,
          `/movie/${id}`,
          {
            movieId: id,
            title: title,
            note: values.note
          }
        )
      })
    )

    showNotification({
      title: "Film inviato",
      message: `"${title}" è stato inviato a ${selectedFriends.length} amico${selectedFriends.length > 1 ? 'i' : ''}`,
      icon: <IconMailFast />,
    })

    setModalOpened(false)
    setIsLoading(false)
    form.reset()
    setSelectedFriends([])

  }

  const removeFriend = (friendId: string) => {
    setSelectedFriends(prev => prev.filter(f => f.id !== friendId))
  }

  return (
    <>
      <Button
        loading={isLoading}
        variant="default"
        size="xs"
        rightIcon={<IconShare size={14} />}
        onClick={() => {
          setModalOpened(true)
        }
      }
      >
        Consiglia
      </Button>

      <Modal
        opened={modalOpened}
        centered
        size="md"
        onClose={() => {
          setModalOpened(false)
          form.reset()
          setSelectedFriends([])
        }}
        title={`Consiglia "${title}" ad amici`}
      >
        {isLoading && <Overlay opacity={0.3} color="#000"/>}

        <form
          onSubmit={form.onSubmit((values) => {
            sendMovieSuggest(values)
          })}>

          <AutocompleteUsers
            singleSelection={false}
            onSubmit={(user: any) => {
              // Aggiungo l'amico se non è già stato selezionato
              setSelectedFriends(prev => {
                if (prev.find(f => f.id === user.id)) {
                  return prev
                }
                return [...prev, { id: user.id, name: user.name, avatar: user.avatar }]
              })
            }}
            onSearching={() => {
              // Non faccio nulla di particolare, l'autocomplete si resetta da solo
            }}
            searchOnlyFriends
          />

          {selectedFriends.length > 0 && (
            <Paper shadow="xs" p="xs" mt="sm" withBorder>
              <Group spacing="xs">
                {selectedFriends.map(friend => (
                  <Badge
                    key={friend.id}
                    size="lg"
                    variant="outline"
                    rightSection={
                      <ActionIcon
                        size="xs"
                        color="white"
                        radius="xl"
                        variant="transparent"
                        onClick={() => removeFriend(friend.id)}
                      >
                        <IconX size={10} />
                      </ActionIcon>
                    }
                  >
                    {friend.name}
                  </Badge>
                ))}
              </Group>
            </Paper>
          )}

          <Textarea
            label="Aggiungi una nota"
            autosize
            maxLength={400}
            minRows={2}
            maxRows={4}
            mt="md"
            icon={<IconClipboardText size={14} />}
            {...form.getInputProps('note')}
          />

          <Button
            type="submit"
            fullWidth
            mt="xl"
            loading={isLoading && true}
            disabled={selectedFriends.length === 0}
          >
            Invia consiglio{selectedFriends.length > 0 ? ` a ${selectedFriends.length} amic${selectedFriends.length > 1 ? 'i' : 'o'}` : ''}
          </Button>

        </form>

        <Divider my="lg" label="Oppure condividi esternamente" labelPosition="center" />

        <Group>

          <Button
            component="a"
            variant="default"
            rightIcon={<IconBrandWhatsapp size={14} />}
            href={`whatsapp://send?text=${message} ${url}`}
            target="_blank"
          >
            Whatsapp
          </Button>

          <Button
            component="a"
            variant="default"
            rightIcon={<IconBrandTelegram size={14} />}
            href={`tg://msg?text=${message} ${url}`}
            target="_blank"
          >
            Telegram
          </Button>

          <Button
            variant="default"
            rightIcon={<IconClipboard size={14} />}
            onClick={
              () => {
                clipboard.copy(`${message} ${url}`)
              }
            }
          >
            {clipboard.copied ? 'Copiato' : 'Copia in clipboard'}
          </Button>

        </Group>

      </Modal>
    </>
  )

}
